import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ApiEncryptDecrypt from "../../Utils/Encryption";
import axiosInstance from "../../Utils/axiosInstance";

const Key = import.meta.env.VITE_Encryption_Decryption_Key;

export const fetchCustomerDetails = createAsyncThunk(
  "customer/fetchCustomerDetails",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const getLoggedInUser = JSON.parse(
        sessionStorage.getItem("loggedInUser")
      );
      if (!getLoggedInUser) return rejectWithValue("User not logged in");
      const data = {
        ...payload, // dynamic data passed from component
        AssoID: getLoggedInUser?.AutoID,
        LoginToken: getLoggedInUser.LoginToken,
        AppVersion: getLoggedInUser?.AppVersion,
        DeviceType: "Web",
      };
      const encryptedData = await ApiEncryptDecrypt.encryptString(
        Key,
        JSON.stringify(data)
      );
      const res = await axiosInstance.post("/GetCustomerDetails", {
        Body: encryptedData,
      });
      const decryptedRes = await ApiEncryptDecrypt.decryptString(
        Key,
        res.data.body
      );
      const obj = JSON.parse(decryptedRes);
      if (obj.Status === 3) {
        dispatch(uiAction.updateAppType("Business"));
        sessionStorage.clear();
        return rejectWithValue("Session expired");
      }
      return obj.Response;
    } catch (error) {
      return rejectWithValue(
        error?.message || "Error fetching customer details"
      );
    }
  }
);

const customerSlice = createSlice({
  name: "customer",
  initialState: {
    customerDetails: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCustomer: (state) => {
      state.customerDetails = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.customerDetails = action.payload;
      })
      .addCase(fetchCustomerDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCustomer } = customerSlice.actions;
export default customerSlice.reducer;
